import axios from "axios";

export const uploadFile = async (fileName, blob) => {
    const data = new FormData();
    data.append('file', blob, fileName);
    const response = await axios.post(`/api/files`, data, {
        headers: {
            'Content-Type': `multipart/form-data; boundary=${data._boundary}`,
        },
        timeout: 30000,
    });
    return response.data
};

export const downloadFile = async (id) => {
    const response = await axios.get(`/api/files/${id}`);
    return response.data
};

export const deleteFile = async (id) => {
    await axios.delete(`/api/files/${id}`);
    return true
};

export function showfile(base64String, type = 'image/jpeg') {
    const blob = b64toBlob(base64String, type);
    const blobUrl = URL.createObjectURL(blob);
    window.open(blobUrl, '_blank');
};

const b64toBlob = (b64Data, contentType = 'image/jpeg', sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
};
